import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-joint-venture',
  templateUrl: './joint-venture.component.html',
  styleUrls: ['./joint-venture.component.css']
})
export class JointVentureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/joint-venture/joint-venture.component.ts